<bz-input
  type="search"
  appearance="filled"
  [value]="draft()"
  (valueChange)="onDraftInput($event)"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  [ariaLabel]="ariaLabel()"
>
  <bz-icon bzInputPrefix class="bz-search-input__icon" [icon]="searchIcon" />
  @if (draft()) {
    <button bzInputSuffix type="button" class="bz-search-input__clear" aria-label="Clear" [disabled]="disabled()" (click)="clear()">
      <bz-icon [icon]="closeIcon" size="sm" />
    </button>
  }
</bz-input>
